import styled from 'styled-components'

export const LinksContainer = styled.div`
  min-height: ${({ mobile }) => (mobile ? '100vh' : '91vh')};
  padding: max(2vw, 3vh);
  border-right: 2px black solid;
  color: white;
  background: linear-gradient(
    to bottom right,
    var(--color-quaternary),
    #543355
  );
`

export const Links = styled.ul`
  display: flex;
  flex-direction: column;
  gap: max(2vw, 2vh);
  & a {
    transition: all 0.2s;
  }
  & a:hover {
    text-decoration: underline;
  }
`
